<template>
  <nav
    class="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white 
    flex flex-wrap items-center justify-between relative md:w-56 z-10 py-4 px-6">
    <div
      class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
      <!-- Toggler -->
      <button
        class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
        type="button" v-on:click="toggleCollapseShow('bg-white m-2 py-3 px-6')">
        <i class="fas fa-bars"></i>
      </button>
      <!-- Brand -->
      <router-link to="/" v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate"
          class="md:block text-left inline-block whitespace-nowrap text uppercase font-bold p-2 px-0" :class="[
            isActive
              ? 'text-emerald-500 hover:text-emerald-600'
              : 'text-blueGray-600 hover:text-blueGray-500',
          ]">
          DASHBOARD
        </a>
      </router-link>
      <!-- User -->
      <ul class="md:hidden items-center flex flex-wrap list-none">
        <!-- <li class="inline-block relative">
          <notification-dropdown />
        </li> -->
        <li class="inline-block relative">
          <user-dropdown />
        </li>
      </ul>
      <!-- Collapse -->
      <div
        class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-2 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
        v-bind:class="collapseShow">

        <!-- Divider -->
        <hr class="my-4 md:min-w-full" />

        <!-- Heading -->
        <h6 class="md:min-w-full text-blueGray-400 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
          MAIN
        </h6>

        <ul class="md:flex-col md:min-w-full flex flex-col list-none">
          <li class="items-center">
            <router-link to="/general" v-slot="{ href, navigate, isActive }">
              <a :href="href" @click="navigate" class="text-sm py-3 block flex" :class="[
                isActive
                  ? 'text-emerald-500 hover:text-emerald-600'
                  : 'text-blueGray-700 hover:text-blueGray-500',
              ]">
                <img class="mr-2" src="@/assets/img/school_med.png" width="24" height="24" viewbox="0 0 24 24"
                  style="max-width: 25px!important; border-radius: 0.3rem;">
                General
              </a>
            </router-link>
          </li>

          <!-- Divider -->
          <hr class="my-4 md:min-w-full" />
          <!-- Heading -->
          <h6 class="md:min-w-full text-blueGray-400 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
            BINLA EDUCATION
          </h6>

          <!-- Navigation -->
          <li class="items-center">
            <router-link to="/binla_education" v-slot="{ href, navigate, isActive }">
              <a :href="href" @click="navigate" class="text-sm py-3 block flex" :class="[
                isActive
                  ? 'text-emerald-500 hover:text-emerald-600'
                  : 'text-blueGray-700 hover:text-blueGray-500',
              ]">
                <img class="mr-2" src="@/assets/img/binla_education.png" width="24" height="24" viewbox="0 0 24 24"
                  style=" max-width: 25px!important; border-radius: 0.3rem;">
                  Binla Education
              </a>
            </router-link>
          </li>

          <!-- <li class="items-center">
            <router-link to="/binla_book" v-slot="{ href, navigate, isActive }">
              <a :href="href" @click="navigate" class="text-sm py-3 block flex" :class="[
                isActive
                  ? 'text-emerald-500 hover:text-emerald-600'
                  : 'text-blueGray-700 hover:text-blueGray-500',
              ]">
                <img class="mr-2" src="@/assets/img/binla_book.png" width="24" height="24" viewbox="0 0 24 24"
                  style=" max-width: 25px!important; border-radius: 0.3rem;">
                  Binla Book
              </a>
            </router-link>
          </li>
          <li class="items-center">   
            <router-link to="/binla_channel" v-slot="{ href, navigate, isActive }">
              <a :href="href" @click="navigate" class="text-sm py-3 block flex" :class="[
                isActive
                  ? 'text-emerald-500 hover:text-emerald-600'
                  : 'text-blueGray-700 hover:text-blueGray-500',
              ]">
                <img class="mr-2" src="@/assets/img/binla_channel.png" width="24" height="24" viewbox="0 0 24 24"
                  style=" max-width: 25px!important; border-radius: 0.3rem;">
                  Binla Channel
              </a>
            </router-link>         
          </li> -->

          <!-- Divider -->
          <hr class="my-4 md:min-w-full" />
          <!-- Heading -->
          <h6 class="md:min-w-full text-blueGray-400 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
            DAHLA SERVICE
          </h6>

          <!-- Navigation -->
          <li class="items-center">
            <router-link to="/dahla_calendar" v-slot="{ href, navigate, isActive }">
              <a :href="href" @click="navigate" class="text-sm py-3 block flex" :class="[
                isActive
                  ? 'text-emerald-500 hover:text-emerald-600'
                  : 'text-blueGray-700 hover:text-blueGray-500',
              ]">
                <img class="mr-2" src="@/assets/img/dahla_calendar.png" width="24" height="24" viewbox="0 0 24 24"
                  style=" max-width: 25px!important; border-radius: 0.3rem;">
                Dahla Calendar
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link to="/dahla_elog" v-slot="{ href, navigate, isActive }">
              <a :href="href" @click="navigate" class="text-sm py-3 block flex" :class="[
                isActive
                  ? 'text-emerald-500 hover:text-emerald-600'
                  : 'text-blueGray-700 hover:text-blueGray-500',
              ]">
              <img class="mr-2" src="@/assets/img/dahla_e-log.png" width="24" height="24" viewbox="0 0 24 24"
                style=" max-width: 25px!important; border-radius: 0.3rem;">
              Dahla E-Log
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link to="/dahla_co_act" v-slot="{ href, navigate, isActive }">
              <a :href="href" @click="navigate" class="text-sm py-3 block flex" :class="[
                isActive
                  ? 'text-emerald-500 hover:text-emerald-600'
                  : 'text-blueGray-700 hover:text-blueGray-500',
              ]">
              <img class="mr-2" src="@/assets/img/dahla_co-act.png" width="24" height="24" viewbox="0 0 24 24"
                style=" max-width: 25px!important; border-radius: 0.3rem;">
              Dahla Co-Act
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link to="/dahla_alumni" v-slot="{ href, navigate, isActive }">
              <a :href="href" @click="navigate" class="text-sm py-3 block flex" :class="[
                isActive
                  ? 'text-emerald-500 hover:text-emerald-600'
                  : 'text-blueGray-700 hover:text-blueGray-500',
              ]">
              <img class="mr-2" src="@/assets/img/dahla_alumni.png" width="24" height="24" viewbox="0 0 24 24"
                style=" max-width: 25px!important; border-radius: 0.3rem;">
              Dahla Alumni
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link to="/dahla_smartgrade" v-slot="{ href, navigate, isActive }">
              <a :href="href" @click="navigate" class="text-sm py-3 block flex" :class="[
                isActive
                  ? 'text-emerald-500 hover:text-emerald-600'
                  : 'text-blueGray-700 hover:text-blueGray-500',
              ]">
              <img class="mr-2" src="@/assets/img/dahla_smartgrade.png" width="24" height="24" viewbox="0 0 24 24"
                style=" max-width: 25px!important; border-radius: 0.3rem;">
              Dahla SmartGrade
              </a>
            </router-link>
          </li>

          <li class="items-center">
          </li>
        </ul>

      </div>
    </div>
  </nav>
</template>

<script>
// import NotificationDropdown from "@/components/Dropdowns/NotificationDropdown.vue";
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";

export default {
  data() {
    return {
      collapseShow: "hidden",
    };
  },
  methods: {
    toggleCollapseShow: function (classes) {
      this.collapseShow = classes;
    },
  },
  components: {
    // NotificationDropdown,
    UserDropdown,
  },
};
</script>
